<template>
  <v-card
    :name="id"
    :id="id"
    class="pa-2 primary4 card-generic"
    outlined
    tile
    height="175"
    style="border-radius: 20px !important; border: 0px;"
    @click="handlerClick(id)"
  >
    <v-container fluid pa-0 fill-height>
      <v-row align="center" justify="center">
        <v-col cols="auto">
          <div class="text-center">
            <v-icon class="primary1--text mb-4" size="56" style="width: 56px;">$vuetify.icon.{{ icon }}</v-icon>
            <div class="primary1--text font-weight-bold subtitle-1 primary1--text">{{ msg }}</div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import Redirect from '@/services/Redirect'

export default {
  name: 'CardGeneric',

  props: { icon: String, msg: String, id: Number },

  methods: {
    handlerClick(value) {
      switch (value) {
        case 0:
          this.$router.push('/consultarUnimed')
          break
        case 2:
          this.$router.push('/dirigentes')
          break
        case 3:
          this.$router.push('/relatorios')
          break
        case 4:
          this.$router.push('/administracao')
          break
        case 5:
          this.$router.push('/transacaoOnline')
          break
        case 6:
          this.$router.push('/pendencias')
          break
        case 7:
          this.redirectLink()
          break
        default:
          this.$emit('click')
      }
    },
    async redirectLink() {
      let redirect = new Redirect(localStorage.getItem('tokenBearer'), this.$appConfig.config.API)
      let response = await redirect.getCadBenef()
      let url = response.data

      document.getElementById(this.id).blur()

      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.v-card--link:before {
  border-radius: 20px;
}

.card-generic {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
</style>
